import React, { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useInstantSearch, useSearchBox } from 'react-instantsearch'

import { useSearchParams } from 'shared/hooks'

import { NotFound } from './pages/not-found'
import { IS_ON_MOBILE_APP } from './constants'

interface LayoutProps {
  children: ReactNode
}

export function Layout(props: LayoutProps) {
  const { children } = props

  const { results } = useInstantSearch()

  const { refine } = useSearchBox()

  const query = useSearchParams()

  useEffect(() => {
    if (IS_ON_MOBILE_APP) {
      refine(query.term)
    }
  }, [query.term, refine])

  if (!results.__isArtificial && results.nbHits === 0) {
    return <NotFound />
  }

  return <React.Fragment>{children}</React.Fragment>
}
